<template>
  <div class="wrapper">
    <div class="skillbar" data-percent="100%">
        <div class="skillbar-title">{{work.company}}</div>
        <div class="skill-bar-percent" v-if="work.type === 'year'">{{work.time}} {{ $t('resume.years') }}</div>
        <div class="skill-bar-percent" v-else-if="work.type === 'month'">{{work.time}} {{ $t('resume.months') }}</div>
        <div class="skill-bar-percent" v-else>{{work.start}} - {{ $t('resume.now') }}</div>
        <div class="skillbar-bar" style="width: 100%"></div>
        <div class="skillbar-subtitle">{{work.position}}</div>
        <div class="skillbar-desc" v-html="$t('resume.projects', { projects: work.projects })"></div>
        <div class="skillbar-desc-act" v-for="(activity, key ) in work.activities" :key="key">
          <div class="skillbar-desc-act-content"><li></li> <p class="item-act">{{ activity }}</p></div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SkillBar",
  props: ['work'],
}
</script>

<style lang="scss">
.wrapper {
    position: sticky;
}

.skillbar {
  position: relative;
  display: block;
  width: 100%;
  margin-bottom: 30px;
}

.skillbar-bar:before {
  background: $blackSolid;
  content: "";
  height: 3px;
  position: absolute;
  width: 100%;
  z-index: -1;
}

.skillbar-bar {
  height: 3px;
  width: 0px;
  background: $greenDark;
  transition-property: width, background-color;
}

.skillbar-title {
  color: $green;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  display: inline-block;
}

.skillbar-subtitle {
  color: $green;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  display: inline-block;
}

.skillbar-desc {
  color: $green;
  font-size: 12px;
  font-weight: 600;
}

.skillbar-desc-act {
  color: $greenMidDark;
  font-size: 12px;
  font-weight: 600;
}

.skillbar-desc-act-content {
    display: flex;
    margin: 2px;
}

.skill-bar-percent {
  float: right;
  display: inline-block;
  color: $green;
  font-size: 11px;
  font-weight: 600;
}

</style>
